module.exports = __webpack_public_path__ + "img/biximing.03b29aa7.png";